import React from 'react';
import RecommendationTitle from '../../components/shared/recommendation-title';
import {
  AgencyEnquiryFormWithFragment,
  InView,
  RecommendationsEnquirySection,
  SectionWrapper,
} from '../../components';
import { COMPONENT_IDS, PROFILE_TIERS } from '../../constants';
import AgencyRecommendations from '../../components/agency-recommendations/agency-recommendation';
import { OverallStarRating } from '../../components/shared/recommendations/types';
import { ReviewsProvider } from '../../components/recommendations-enquiry-section';

type AgencyRecommendationsWithStarRatingsProps = {
  agencyId: number;
  title: string;
  starRatingsEnabled: boolean;
  profileTier: PROFILE_TIERS;
  onActivate: (inView: boolean) => void;
  onSubmit: () => void;
  overallStarRating?: OverallStarRating;
};

export const AgencyRecommendationsWithStarRatings: React.FC<
  AgencyRecommendationsWithStarRatingsProps
> = ({
  agencyId,
  title,
  overallStarRating,
  starRatingsEnabled,
  profileTier,
  onActivate,
  onSubmit,
}) => (
  <SectionWrapper componentId={COMPONENT_IDS.recommendations}>
    <ReviewsProvider>
      <RecommendationTitle
        overallStarRating={overallStarRating}
        title={title}
      />
      <RecommendationsEnquirySection
        recommendations={
          <AgencyRecommendations
            agencyId={agencyId}
            starRatingsEnabled={starRatingsEnabled}
          />
        }
        enquiryForm={
          <InView onActivate={onActivate}>
            <AgencyEnquiryFormWithFragment
              agencyId={agencyId}
              withBackground
              onSubmit={onSubmit}
            />
          </InView>
        }
        profileTier={profileTier}
      />
    </ReviewsProvider>
  </SectionWrapper>
);

export default AgencyRecommendationsWithStarRatings;
